module.exports = __webpack_public_path__ + "img/JOD.1d8f73ab.svg";